import { render, staticRenderFns } from "./SCM.vue?vue&type=template&id=53f7107d&scoped=true&"
import script from "./SCM.vue?vue&type=script&lang=js&"
export * from "./SCM.vue?vue&type=script&lang=js&"
import style0 from "./SCM.vue?vue&type=style&index=0&id=53f7107d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f7107d",
  null
  
)

export default component.exports